import { useState } from "react";

const useRequiredFields = (initialRequired = {}) => {
    const [requiredFields, setRequiredFields] = useState(initialRequired);

    const makeFieldRequired   = (name) => setRequiredFields(prev => ({ ...prev, [name]: true }));
    const makeFieldOptional   = (name) => setRequiredFields(prev => ({ ...prev, [name]: false }));
    const toggleFieldRequired = (name) => setRequiredFields(prev => ({ ...prev, [name]: !prev[name] }));
    const isFieldRequired     = (name) => !!requiredFields[name];

    return { makeFieldRequired, makeFieldOptional, toggleFieldRequired, isFieldRequired };
};

export default useRequiredFields;
